import { useEnvControllerContext } from './env-controller-context';

import DropdownComp, {
  Option,
} from 'wa-storybook/components/inputs/dropdown/dropdown-comp';

export const EnvController = () => {
  const { selectedEnvironment, setSelectedEnvironment } =
    useEnvControllerContext();

  const dropdownOptions = ['live', 'test', 'integration'].map(environment => ({
    label: environment.charAt(0).toUpperCase() + environment.slice(1),
    value: environment,
  }));

  return (
    <DropdownComp
      labelInner='Backend Environment:'
      placeholderText='Select an Environment'
      options={dropdownOptions}
      onChange={(option: Option) => setSelectedEnvironment(option.value)}
      selectedItem={dropdownOptions.find(
        option => option.value === selectedEnvironment,
      )}
    />
  );
};
